import { Component, Inject, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '../../base/base.component';
import { User } from 'app/shared/models/user';
import { UserService } from 'app/shared/services/user.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'user-selection-dialog',
  templateUrl: './user-selection-dialog.component.html',
  styleUrls: ['./user-selection-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserSelectionDialogComponent extends BaseComponent implements OnInit, AfterViewInit {

  title: string;
  users: User[];
  selectedUsers: User[] = [];
  allowEdit = true;
  hasChanges = false;

  constructor(
    public dialogRef: MatDialogRef<UserSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService) {
    super();
  }

  ngOnInit() {
    this.title = this.data.title || 'Select Users';
    this.allowEdit = this.data.allowEdit;
    let users = this.data.users;
    if (users.length === 0) {
      this.userService.getActiveUsers().pipe(take(1)).subscribe((response: User[]) => users = response);
    }
    this.users = [...users];
    if (this.data && this.data.selectedUsers) {
      if (this.data.selectedUsers.length > 0) {
        const item = this.data.selectedUsers[0];
        if (typeof item === 'number') {
          this.selectedUsers = [...users.filter((i) => this.data.selectedUsers.indexOf(i.id) > -1)];
        }
        else {
          this.selectedUsers = [...this.data.selectedUsers];
        }
      }
    }
  }

  ngAfterViewInit() {
    this.hasChanges = !(this.data && this.data.selectedUsers && (this.data.selectedUsers.length > 0));
  }

  selectedUsersChanged(users: User[]) {
    this.selectedUsers = [...users];
    this.hasChanges = true;
  }

  save(): void {
    this.dialogRef.close({
      availableUsers: this.users,
      selectedUsers: this.selectedUsers,
    });
  }
}
